import { render } from "./FooterSliderLabelButton.vue?vue&type=template&id=7603ef6a"
import script from "./FooterSliderLabelButton.vue?vue&type=script&lang=js"
export * from "./FooterSliderLabelButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__